/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { func, shape, string } from 'prop-types';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        padding: '50px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& .survey_text': {
            fontSize: '0.8em',
        },
    },
    '@keyframes stroke': {
        '100%': {
            strokeDashoffset: '0',
        },
    },
    '@keyframes scale': {
        '0%, 100%': {
            transform: 'none',
        },
        '50%': {
            transform: 'scale3d(1.1, 1.1, 1)',
        },
    },
    '@keyframes fill': {
        '100%': {
            boxShadow: `inset 0px 0px 0px 40px ${theme?.palette?.primaryButton}`,
        },
    },
    checkmarkCircle: {
        strokeDasharray: '166',
        strokeDashoffset: '166',
        strokeWidth: '2',
        strokeMiterlimit: '10',
        stroke: theme?.palette?.primaryButton,
        fill: 'none',
        animation: '$stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards',
    },
    checkmark: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'inline-block',
        strokeWidth: 4,
        stroke: theme?.palette?.white,
        strokeMiterlimit: '10',
        margin: '14px 5px 14px 0',
        verticalAlign: 'middle',
        boxShadow: `inset 0px 0px 0px ${theme?.palette?.primaryButton}`,
        animation: '$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both',
    },
    checkmarkCheck: {
        transformOrigin: '50% 50%',
        strokeDasharray: '38',
        strokeDashoffset: '5',
        animation: '$stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards',
    },
    checkBoxContainer: {
        textAlign: 'center',
    },
    btnContainer: {
        marginTop: '40px',
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'space-evenly',
    },
    primaryButtonStyle: {
        width: '40%',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '5px 0',
        borderRadius: '30px',
        color: theme.palette.white,
        backgroundColor: theme.palette.colorPrimary,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.colorPrimary,
        },
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
        },
    },
    secondaryButtonStyle: {
        width: '40%',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '5px 0',
        boxShadow: 'none',
        borderRadius: '30px',
        color: theme.palette.black,
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.black}`,
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.grey8,
        },
        '@media screen and (max-width: 400px)': {
            fontSize: '12px',
        },
    },
}));

const CanceledSubscriptionSuccess = ({
    handleModal, subscription, setOpenSuccess, setOpenCancelSurveyForm, handleCancel,
}) => {
    const classes = useStyles();

    const handleContinue = () => {
        setOpenSuccess(false);
        setOpenCancelSurveyForm(true);
    };
    const handleClose = () => {
        handleModal('', subscription.ruleId, 'close');
        handleCancel('cancel', subscription.ruleId, 'close');
    };

    return (
        <div className={classes.container}>
            <div className={classes.checkBoxContainer}>
                <p>Your subscription has been successfully <b>CANCELLED</b>.</p>
                <svg
                    className={classes.checkmark}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                >
                    <circle className={classes.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                    <path className={classes.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                </svg>
            </div>
            <p id="survey_text">Please take the following survey to help us improve our service to you.</p>
            <div className={classes.btnContainer}>
                <Button className={classes.secondaryButtonStyle} onClick={handleClose}>Close</Button>
                <Button className={classes.primaryButtonStyle} onClick={handleContinue}>Continue</Button>
            </div>
        </div>
    );
};

CanceledSubscriptionSuccess.propTypes = {
    subscription: shape({
        ruleId: string,
    }),
    setOpenSuccess: func.isRequired,
    handleModal: func.isRequired,
    handleCancel: func.isRequired,
    setOpenCancelSurveyForm: func.isRequired,
};

CanceledSubscriptionSuccess.defaultProps = {
    subscription: {},
};

export default CanceledSubscriptionSuccess;
